<script setup lang="ts">
export interface DialogFooterContentProps {}
</script>

<template>
  <slot />
</template>
